export enum InvestorFileTypes {
  INVESTOR_SUBSCRIPTION_BULLETIN = 'Boletim de subscrição',
  INVESTOR_SIGNATURE_CARD = 'Cartão de assinaturas',
  INVESTOR_ADDRESS = 'Comprovantes de endereço',
  INVESTOR_PROFESSIONAL_STATEMENT = 'Declaração de investidor profissional',
  INVESTOR_QUALIFIED_STATEMENT = 'Declaração de investidor qualificado',
  INVESTOR_IDENTIFICATION_DOCUMENT = 'Documentos de identificação',
  INVESTOR_CITIZENSHIP = 'Documentos de cidadania',
  INVESTOR_AUTHORIZATIONS_DOC_PRODURER = 'Documentos de identificação do representante',
  INVESTOR_REPUTATIONAL_DOSSIER = 'Dossiê reputacional',
  INVESTOR_REGISTRATION_FORM = 'Ficha cadastral',
  INVESTOR_TAX_INFORMATION = 'Informações fiscais',
  INVESTOR_OTHERS = 'Outros',
  INVESTOR_AUTHORIZATIONS_WARRANT = 'Procuração',
  INVESTOR_QUESTIONNAIRE = 'Questionários suitability',
  INVESTOR_CONTRACT_OF_ADHESION = 'Termo de adesão',
  INVESTOR_AUTHORIZATION_TERM = 'Termo de autorização',
  INVESTOR_DISQUALIFICATION_TERM = 'Termo de desenquadramento',
  INVESTOR_REJECT_SUITABILITY_TERM = 'Termo de recusa do suitability',
  INVESTOR_PAYMENT_ACCOUNT_OPENING_TERM = 'Termo de Abertura de Conta de Pagamento',
  INVESTOR_COMMITMENT = 'Compromisso de investimento',
  INVESTOR_MANAGMENT_CONTRACT = 'Contrato de Gestão',
  INVESTOR_LEVEL_FILE_TYPE = 'Declaração do investidor',
  INVESTOR_TAX_CONDITION = 'Declaração de condição tributária',
  INVESTOR_MANAGED_PORTFOLIO = 'Contrato de carteira administrada'
}
